/**
 * Home SALE call-to-action (black section). The SALE ring spins forever
 * (IX2 a-23) and the discount sticker does a one-shot jiggle on scroll-in
 * (IX2 jiggle). Grid placement ids match the Webflow export.
 */
import type { FC } from 'react'

import { useEffect, useRef } from 'react'
import Link from 'next/link'

import { gsap } from '@/lib/gsap'

export const SaleCta: FC = () => {
    const circleRef = useRef<HTMLImageElement>(null)
    const stickerRef = useRef<HTMLDivElement>(null)

    useEffect(() => {
        const ctx = gsap.context(() => {
            if (circleRef.current) {
                gsap.to(circleRef.current, { rotation: 360, duration: 10, ease: 'none', repeat: -1 })
            }

            if (stickerRef.current) {
                gsap.to(stickerRef.current, {
                    keyframes: { rotation: [-5, 5, -5, 5, -5, 5, -5, 5, -5, 5, 0] },
                    duration: 1.1,
                    ease: 'none',
                    scrollTrigger: { trigger: stickerRef.current, start: 'top 83%', once: true }
                })
            }
        })

        return () => ctx.revert()
    }, [])

    return (
        <div className='section black-section'>
            <div className='container'>
                <div className='cta-container'>
                    <div className='w-layout-grid grid-6-col'>
                        <div id='w-node-_570e58c7-60e4-68d3-19c4-9d8388c3abd1-ee6eeb4f' className='content'>
                            <div className='sale-badge-container'>
                                <div className='sale-circle-container'>
                                    <img ref={circleRef} src='/images/SALE-Circle.svg' loading='lazy' alt='' className='sale-circle' />
                                    <div className='sale-badge-holder'>
                                        <img src='/images/Mark-Simple.svg' loading='lazy' alt='' className='sale-logo-mark' />
                                    </div>
                                    <div className='sale-sticker-holder'>
                                        <div ref={stickerRef} className='sale-sticker-container'>
                                            <div className='sale-sticker-text-holder'>
                                                <div className='_12px-text'>Up to</div>
                                                <div className='sale-text'>70%</div>
                                            </div>
                                            <img src='/images/Sale-Badge.svg' loading='lazy' alt='' className='sale-sticker' />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div id='w-node-_1521a70f-a1c6-18da-cd7a-1eeb1eaff1c9-ee6eeb4f' className='content'>
                            <div className='fade-in-move-on-scroll'>
                                <h2 className='white-text no-margins'>Find out about the sales at your local shop</h2>
                            </div>
                            <div className='fade-in-move-on-scroll'>
                                <div className='top-margin-l'>
                                    <Link href='/contact' className='button white w-button'>FIND SHOPS NEAR YOU</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
